import { isIE } from '../../helpers/accessibility';
export var validateBadNumberInput = function validateBadNumberInput(e) {
  var _e$target, _e$target2, _e$target3, _e$target3$validity;

  return isIE() && (e == null ? void 0 : (_e$target = e.target) == null ? void 0 : _e$target.value) && !/^\d*\.?\d*$/.test(e == null ? void 0 : (_e$target2 = e.target) == null ? void 0 : _e$target2.value) || ((_e$target3 = e.target) == null ? void 0 : (_e$target3$validity = _e$target3.validity) == null ? void 0 : _e$target3$validity.badInput);
};